import { render, staticRenderFns } from "./CouponCategories.vue?vue&type=template&id=50794e9c&scoped=true"
import script from "./CouponCategories.vue?vue&type=script&lang=js"
export * from "./CouponCategories.vue?vue&type=script&lang=js"
import style0 from "./CouponCategories.vue?vue&type=style&index=0&id=50794e9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50794e9c",
  null
  
)

export default component.exports